import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { PsRoutes } from '../../shared/routing/Routes';
import RouterUtils from '../../shared/routing/RouterUtils';
import * as outsourceActions from '../actions/outsourceActions';
import * as exportOutsourceDocsActions from '../actions/exportOutsourceDocsActions';
import ExportOutsourceDocsCard from '../components/export/ExportOutsourceDocsCard';
import { BreadcrumbsManagerInstance } from '../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../shared/breadcrumbs/Breadcrumbs';

class ExportOutsourceDocsScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES,
            Breadcrumbs.MY_OUTSOURCES_DETAIL,
            Breadcrumbs.MY_OUTSOURCES_DOCUMENTS_EXPORT,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    componentDidMount() {
        const { outsource, match } = this.props;

        if ( !outsource || outsource.id !== match.params.id ) {
            this.props.outsourceActions.getCompany(match.params.id);
        }
    }

    componentDidUpdate(prevProps) {
        const {
            location,
            outsource: currentOutsource,
            match: {
                params: {
                    id: currentId,
                },
            },
        } = this.props;

        const {
            outsource: prevOutsource,
            match: {
                params: {
                    id: prevId,
                },
            },
        } = prevProps;

        if ( currentId !== prevId ) {
            window.location.reload();
        }

        if ( currentOutsource !== prevOutsource && currentOutsource ) {
            BreadcrumbsManagerInstance.finishLoading({
                id: Breadcrumbs.MY_OUTSOURCES_DETAIL.id,
                url: RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_DETAIL, { id: currentOutsource.id }),
                description: currentOutsource.name,
            });

            BreadcrumbsManagerInstance.finishLoading({
                id: Breadcrumbs.MY_OUTSOURCES_DOCUMENTS_EXPORT.id,
                url: location.pathname,
                description: I18nUtils.tr('TR_EXPORTAR'),
            });

            this.setState({
                breadcrumbs: [...BreadcrumbsManagerInstance.breadcrumbs()],
            });
        }
    }

    render() {
        const { outsource, outsourceError } = this.props;
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_EXPORTAR_DOCUMENTOS_DE_MI_SUBCONTRATA')} breadcrumbs={breadcrumbs}>
                {
                    outsourceError ? (
                        <section className={'error-section'}>
                            <h3 className={'text-center'}>{this.props.outsourceError}</h3>
                        </section>
                    ) : null
                }
                {
                    outsource ? (
                        <ExportOutsourceDocsCard outsourceId={this.props.outsource.id}/>
                    ) : null
                }
            </PsPage>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        outsource: state.exportOutsourceDocs.outsource,
        outsourceError: state.exportOutsourceDocs.outsourceError,
    };
};

const mapDispatchToProps = dispatch => ( {
    outsourceActions: bindActionCreators(outsourceActions, dispatch),
    exportOutsourceDocsActions: bindActionCreators(exportOutsourceDocsActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(ExportOutsourceDocsScreen);



// WEBPACK FOOTER //
// ./src/app/outsource/screens/ExportOutsourceDocsScreen.js